import * as React from "react";
const SvgDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 15, height: 15, viewBox: "0 0 15 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 5L7 11L13 5", stroke: "#703EFF", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgDown;
